module.exports = __webpack_public_path__ + "img/PrivacySettings.23c6f83b.svg";